import { render, staticRenderFns } from "./TheImportContactsPanel.vue?vue&type=template&id=08cb2f08&scoped=true"
import script from "./TheImportContactsPanel.vue?vue&type=script&lang=js"
export * from "./TheImportContactsPanel.vue?vue&type=script&lang=js"
import style0 from "./TheImportContactsPanel.vue?vue&type=style&index=0&id=08cb2f08&prod&lang=scss"
import style1 from "./TheImportContactsPanel.vue?vue&type=style&index=1&id=08cb2f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cb2f08",
  null
  
)

export default component.exports